const BundleAddToCart = (function(){
  let observer = null;

  const createObserver = () => {
    return new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const card = entry.target;
        const bundleDiv = card.querySelector(".parant-bundle-product.hasbundle");
        if (!bundleDiv) {
          observer.unobserve(card);
          return;
        }

        const productURL = bundleDiv.getAttribute("data-product-link");

        // Prevent duplicate calls
        if (bundleDiv.dataset.loaded === "1") {
          observer.unobserve(card);
          return;
        }

        fetch(productURL)
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement("div");
            temp.innerHTML = html;

            // Extract the div.bundle-inputs from PDP
            const bundleInputs = temp.querySelector(".bundle-inputs");

            if (bundleInputs) {
              // Append into the collection card
              bundleDiv.innerHTML = bundleInputs.innerHTML;
              bundleDiv.dataset.loaded = "1"; // mark as loaded
              observer.unobserve(card);
            }
          })
          .catch(err => console.error("Bundle fetch failed:", err));
      });
    }, { threshold: 0.2 });
  };

  const observe = (root = document) => {
    const cards = root.querySelectorAll("li.grid__item .card-wrapper, .swiper-slide .card-wrapper");
    if (!observer) observer = createObserver();
    cards.forEach(card => observer.observe(card));
  };

  const refresh = (root = document) => {
    // Disconnect and re-observe to ensure newly injected nodes are watched
    if (observer) observer.disconnect();
    observe(root);
  };

  const init = () => observe(document);

  return { init, refresh, observe };
})();

// auto-init on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  BundleAddToCart.init();
});
window.BundleAddToCart = BundleAddToCart;
//document.dispatchEvent(new Event('BundleAddToCartReady'));
